import React, {FC, useEffect, useRef, useState, useLayoutEffect} from "react";
import {Dropdown} from "react-bootstrap";
import IconArrowDown from "../assets/icons/arrow-down.svg";
import "./CustomDropdown.css";
import {ITypeRadar} from "../types";
import {IconContainer} from "../components/ClusterFilter/styles";
import {LIFE_CYCLE_MOCK_DATA} from "../components/ClusterFilter/data";

interface IProps {
  onFilterChange: <T>(filter: string, value?: T) => void;
  title?: string;
  typeRadar: ITypeRadar;
  isResetFilters?: boolean;
  setIsResetFilters?: React.Dispatch<React.SetStateAction<boolean>>;
  currentValues?: string[]; // Текущие значения фильтра
}

export const MySelectWithCheckboxLifeCycle: FC<IProps> = ({
  onFilterChange,
  title,
  typeRadar,
  isResetFilters,
  setIsResetFilters,
  currentValues,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownMaxHeight, setDropdownMaxHeight] = useState<
    number | undefined
  >(undefined);

  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  // Инициализация с переданными значениями из props
  useEffect(() => {
    if (currentValues && currentValues.length > 0) {
      setSelectedOptions(currentValues);
    } else {
      // Если нет переданных значений, инициализируем со всеми опциями
      const allOptions = LIFE_CYCLE_MOCK_DATA.map((option) => option.value);
      setSelectedOptions(allOptions);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isResetFilters) {
      setSelectedOptions([]);
      setIsResetFilters?.(false);
    }
  }, [isResetFilters, setIsResetFilters]);

  useEffect(() => {
    onFilterChange("lifecycle_stage", selectedOptions);
  }, [selectedOptions, onFilterChange]);

  const handleCheckboxChange = (value: string) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((option) => option !== value)
        : [...prevSelected, value]
    );
    if (setIsResetFilters) setIsResetFilters(false);
  };

  const handleSelectAll = () => {
    if (selectedOptions.length === LIFE_CYCLE_MOCK_DATA.length) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions(
        LIFE_CYCLE_MOCK_DATA.map((option) => String(option.value))
      );
    }
    if (setIsResetFilters) setIsResetFilters(false);
  };
  const optionsLevel = LIFE_CYCLE_MOCK_DATA.length;

  useLayoutEffect(() => {
    if (isOpen && dropdownRef.current && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const minMargin = 16;
      const spaceBelow = window.innerHeight - rect.bottom - minMargin;
      const spaceAbove = rect.top - minMargin;
      const desiredMaxHeight = 1000;

      let maxHeight = desiredMaxHeight;

      if (spaceBelow < desiredMaxHeight && spaceBelow > spaceAbove) {
        maxHeight = spaceBelow > 100 ? spaceBelow : 100;
      } else if (spaceAbove < desiredMaxHeight) {
        maxHeight = spaceAbove > 100 ? spaceAbove : 100;
      }

      setDropdownMaxHeight(maxHeight);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <IconContainer ref={ref}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          {title || "Этап жизненного цикла"}
          <span
            style={{
              backgroundColor: "#56B9F2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              color: "white",
              padding: "2px 8px",
            }}
          >
            {selectedOptions.length}
          </span>
        </div>
        <img src={IconArrowDown} alt="arrow" />
      </div>
      {isOpen && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 60,
            borderRadius: "12px",
            border: "1px solid rgba(246, 251, 253, 0.2)",
            background: "#161A1D",
            color: "rgba(255, 255, 255, 0.7)",
            zIndex: 10,
            maxHeight: dropdownMaxHeight ? `${dropdownMaxHeight}px` : undefined,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "8px 0",
              maxHeight: dropdownMaxHeight
                ? `${dropdownMaxHeight}px`
                : undefined,
              overflowY: dropdownMaxHeight ? "auto" : undefined,
              borderRadius: "12px",
            }}
          >
            {LIFE_CYCLE_MOCK_DATA.map((option) => {
              const checked = selectedOptions.includes(String(option.value));
              return (
                <Dropdown.Item
                  key={option.value}
                  as="div"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className={`custom-form-control-label custom-checkbox-row${
                      checked ? " selected" : ""
                    }`}
                  >
                    <div className="custom-form-control-label-title">
                      <span style={{textWrap: "wrap"}}>{option.label}</span>
                    </div>
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() =>
                          handleCheckboxChange(String(option.value))
                        }
                        tabIndex={0}
                      />
                      <span className="custom-checkbox-box">
                        <svg viewBox="0 0 20 20">
                          <polyline
                            points="5 11 9 15 15 7"
                            stroke="white"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </label>
                  </div>
                </Dropdown.Item>
              );
            })}
            <Dropdown.Item as="div">
              <div
                className="custom-form-control-label custom-checkbox-row"
                style={{justifyContent: "flex-start"}}
              >
                <label
                  className="custom-checkbox"
                  style={{marginRight: "12px"}}
                >
                  <input
                    type="checkbox"
                    checked={
                      selectedOptions.length === LIFE_CYCLE_MOCK_DATA.length
                    }
                    ref={(el) => {
                      if (el)
                        el.indeterminate = optionsLevel
                          ? selectedOptions.length > 0 &&
                            selectedOptions.length < optionsLevel
                          : false;
                    }}
                    onChange={handleSelectAll}
                    tabIndex={0}
                    aria-checked={
                      optionsLevel
                        ? selectedOptions.length > 0 &&
                          selectedOptions.length < optionsLevel
                          ? "mixed"
                          : selectedOptions.length === optionsLevel
                          ? "true"
                          : "false"
                        : "false"
                    }
                  />
                  <span className="custom-checkbox-box">
                    <svg viewBox="0 0 20 20">
                      <polyline
                        points="5 11 9 15 15 7"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </label>
                <div className="custom-form-control-label-title">
                  <span style={{textWrap: "wrap"}}>Выделить все</span>
                </div>
              </div>
            </Dropdown.Item>
          </div>
        </div>
      )}
    </IconContainer>
  );
};
